import { useEffect } from 'react';

export const useQualtricsScrollTrigger = (shouldRun: any, scrollThreshold = 300) => {
    useEffect(() => {
        if (!shouldRun) return;

        let isPointerScroll = false;
        let hasTriggered = false;

        const markPointerScroll = () => {
            isPointerScroll = true;
        };
        const unmarkPointerScroll = () => {
            isPointerScroll = false;
        };

        const handleScroll = () => {
            if (!isPointerScroll || hasTriggered) return;
            if (window.scrollY >= scrollThreshold) {
                document.getElementById('QSIFeedbackButton-btn')?.click();
                hasTriggered = true;
            }
        };

        // fires when the user scrolls — checks whether to trigger the survey
        window.addEventListener('scroll', handleScroll);
        // fires on mouse click/press — marks scroll as pointer-initiated
        window.addEventListener('pointerdown', markPointerScroll);
        // fires on touch tap/drag — marks scroll as pointer-initiated on touchscreens
        window.addEventListener('touchstart', markPointerScroll);
        // fires on trackpad/mouse wheel — marks scroll as pointer-initiated
        window.addEventListener('wheel', markPointerScroll);
        // fires on any keypress (tab, arrow keys, etc.) — prevents screen reader / keyboard navigation from triggering the survey
        window.addEventListener('keydown', unmarkPointerScroll);
        // fires when focus moves to a new element — prevents assistive technology focus-driven scrolling from triggering the survey
        window.addEventListener('focusin', unmarkPointerScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('pointerdown', markPointerScroll);
            window.removeEventListener('touchstart', markPointerScroll);
            window.removeEventListener('wheel', markPointerScroll);
            window.removeEventListener('keydown', unmarkPointerScroll);
            window.removeEventListener('focusin', unmarkPointerScroll);
        };
    }, [shouldRun, scrollThreshold]);
};
